import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "90vw",
    [theme.breakpoints.down("sm")]: {
      width: "95vw",
    },
  },
  root: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(1),
    },
  },
}));

const LayoutContainer = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.container}>{props?.children}</div>
    </div>
  );
};
export default LayoutContainer;
